export default __webpack_public_path__ + "static/media/btn_google_play.35a55da5.svg";